import React from 'react';
//import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchPermissionsByModule } from '../../actions/project_actions';


class DetPage extends React.Component {
  // static PropTypes = {
  //     match: PropTypes.object.isRequired,
  // }

  UNSAFE_componentWillMount() {
    this.props.fetchPermissionsByModule(this.props.projectId);
  }

  render () {
    const { isDesignDir, isSustDir, isTeamLeaderAnyProject, isTeamMemberAnyProject, projectsCount, isStudioMember } = this.props.permissionsModule;

    let redirectPageXas = null;

    if (isDesignDir==='undefined' && isSustDir==='undefined' && isTeamLeaderAnyProject==='undefined' 
        && isTeamMemberAnyProject==='undefined' && isStudioMember==='undefined')
    {
        redirectPageXas = null;
    }

    else if (isDesignDir || isSustDir || isTeamLeaderAnyProject || isTeamMemberAnyProject || isStudioMember) {
        redirectPageXas = <Redirect to="/aeProjects" />;
    }
    else if(projectsCount > 0)
    {
        redirectPageXas = <Redirect to="/my-projects" />;        
    }
    else if(isDesignDir===false && isSustDir===false && isTeamLeaderAnyProject===false && isTeamMemberAnyProject===false && isStudioMember===false)
    {
        redirectPageXas = <Redirect to="/search" />;        
    }
    else 
    {
        redirectPageXas=null;
    }

    return (
      <div>
        {redirectPageXas}        
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
      permissionsModule: state.projectsStore.permissionsModule,
  }
}

export default connect(mapStateToProps, { fetchPermissionsByModule }) (DetPage);